import React, { useEffect, useRef, useState } from "react";
import { TextField, Grid } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useLocation, useNavigate } from "react-router-dom";

import {
  GetFinDetailsAPICalls,
  GetFirstTimeLoginAPICall,
  GetModificationrequestsFinUpdateAPICalls,
  stageDetailsAPICall,
} from "./APICalls";

import BankStyles from "./BankDetails.module.scss";

import {
  GetProfileDetailsCommonAPICall,
  LocationCheckAPICall,
  SaveIpAddressAPICall,
} from "../../shared/APICalls";
import keyboardicon from "../../Components/assets/Images/panicongrey.svg";
import ErrorSnackBar from "../../Components/SnackBars/ErrorSnackBar";
import axios from "axios";
import SnackBar from "../../Components/SnackBars/SnackBar";

export default function Profile() {
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(window.location.search);
  const params: any = Object.fromEntries(urlParams.entries());
  const pathName = useLocation().pathname;
  const [loading, setloading] = useState(false);
  const [userDeniedLocation, setuserDeniedLocation] = useState(false);
  const [intervalId, setintervalId] = useState<any>(null);

  const [completedStages, setCompletedStages] = useState<any>();
  const [userData, setUserData] = useState({
    clientCode: "",
    fullName: "",
    mobile: "",
    email: "",
    pan: "",
    TradingPreference: {
      equity: false,
      futures_and_options: false,
      currency: false,
      commodity: false,
      mutual_funds: false,
    },
  });
  const [tradingPreference, setTradingPreference] = useState([]);
  const [message, setMessage] = useState("");
  const [errorMessage, seterrorMessage] = useState("");

  const callBackURL = document.location.href;

  const [IPAddress, setIPAddress] = useState("");
  useEffect(() => {
    window.scrollTo(0, 0);

    const fetchIPAddress = async () => {
      try {
        const response = await axios.get(
          "https://ipapi.co/json/?key=jmJoC4fsM8a1wzvqBWZsEBfRiXtQqsTtz4XdAXaDb27gq2s9QJ",
        );
        // setIPAddress(response.data);
        setIPAddress(response.data?.ip);
      } catch (err: any) {}
    };
    fetchIPAddress();
  }, []);

  useEffect(() => {
    if (IPAddress !== "") {
      LocationCheckAPICall(IPAddress?.trim())
        .then((response: any) => {
          if (response.data.data) {
            sessionStorage.setItem("latitude", response.data.data.latitude);
            sessionStorage.setItem("longitude", response.data.data.longitude);
          }
        })
        .catch((error: any) => {
          seterrorMessage("latitude and longitude not found");
          setTimeout(() => {
            seterrorMessage("");
          }, 5000);
        });
    }
  }, [IPAddress]);

  useEffect(() => {
    window.scrollTo(0, 0);

    GetFirstTimeLogin();
    // StageDetails();
  }, []);

  const StageDetails = (reqId: any) => {
    let obj: any = {
      stage: "income_details",
      request_id: reqId,
    };

    stageDetailsAPICall(obj)
      .then((response: any) => {
        if (response?.data?.data.request_id) {
          sessionStorage.setItem(
            "finupdateRequestID",
            response?.data?.data.request_id,
          );
        }

        if (response?.data?.data.next_stage === "up_to_date") {
          sessionStorage.setItem(
            "next_update",
            response?.data?.data.next_update,
          );
          navigate("/finupdate/up_to_date");
        } else {
          if (response?.data?.data.next_stage === "congratulations") {
            navigate("/finupdate/completed");
          } else {
            navigate("/finupdate/documents_upload");
          }
        }
      })
      .catch((error: any) => {});
  };

  const SaveIpAddress = (responseData: any) => {
    let obj: any = {
      request_id: responseData.request_id,
      update_component: "financial_update",
      latitude: sessionStorage.getItem("latitude"),
      longitude: sessionStorage.getItem("longitude"),
    };
    SaveIpAddressAPICall(obj)
      .then((response: any) => {
        // console.log("response", response.data.data);
        if (responseData.next_stage === "congratulations") {
          navigate("/finupdate/completed");
        } else {
          navigate("/finupdate/documents_upload");
        }
      })
      .catch((error: any) => {
        setMessage(error?.response?.data?.message);
        setTimeout(() => {
          setMessage("");
        }, 5000);
      });
  };

  const GetFirstTimeLogin = () => {
    GetProfileDetailsCommonAPICall()
      .then((response: any) => {
        const TP = response.data.data.TradingPreference;

        const filteredData = Object.keys(TP).filter((key) => TP[key] === true);

        const newData: any = filteredData.map((a) => {
          if (a.includes("equity")) {
            return "Equity";
          } else if (a.includes("futures_and_options")) {
            return "Futures and Options";
          } else if (a.includes("mutual_funds")) {
            return "Mutual Funds";
          }
        });

        const uniqueArray = newData.filter(
          (value: any, index: any) => newData.indexOf(value) === index,
        );
        // console.log("TP", uniqueArray);
        setTradingPreference(uniqueArray);

        if (response.data?.data) {
          setUserData(response.data.data);
        }
      })
      .catch((error: any) => {
        // console.log("error", error);
      });
  };

  const GetFinDetails = () => {
    GetFinDetailsAPICalls()
      .then((response: any) => {
        console.log("response", response.data.data);
        if (response?.data?.data.request_id) {
          sessionStorage.setItem(
            "finupdateRequestID",
            response?.data?.data.request_id,
          );
        }

        StageDetails(response?.data?.data.request_id || null);
      })
      .catch((error: any) => {});
  };
  const GetModificationrequestsFinUpdate = () => {
    GetModificationrequestsFinUpdateAPICalls()
      .then((response: any) => {
        if (response?.data?.data.next_stage === "up_to_date") {
          sessionStorage.setItem(
            "next_update",
            response?.data?.data.next_update,
          );
          navigate("/finupdate/up_to_date");
        } else {
          SaveIpAddress(response?.data?.data);
        }
      })
      .catch((error: any) => {
        setMessage(error?.response?.data?.message);
        setTimeout(() => {
          setMessage("");
        }, 5000);
      });
  };

  const handleNext = () => {
    GetFinDetails();
  };

  return (
    <div className={BankStyles.mainWrapper}>
      <ErrorSnackBar message={message} />
      <SnackBar message={errorMessage} />
      <div className={BankStyles.wrapper}>
        <div className={BankStyles.step}>
          <img src={keyboardicon} /> Step 1 of 2
        </div>
        <div className={BankStyles.HeaderSection}>
          <p className={BankStyles.Header}>Profile Details</p>
        </div>
        <p className={BankStyles.subText}>Confirm your profile information</p>
        <div className={BankStyles.txtwrapper}>
          <Grid
            container
            rowSpacing={4}
            columnSpacing={{ xs: 1, sm: 2, md: 5 }}
          >
            <Grid item xs={12} sm={6}>
              <TextField
                className={BankStyles.textfield}
                id="outlined-basic"
                label="Client Code"
                variant="outlined"
                name="fatherFullName"
                value={userData.clientCode}
                inputProps={{
                  sx: {
                    "&::label": {
                      fill: "#111827",

                      fontWeight: 400,
                    },
                    color: "var(--Black-Black-500, #6B7280)",
                    fontSize: "14px",
                  },
                  maxLength: 50,
                  inputMode: "text",
                }}
                sx={{
                  fieldset: {
                    borderColor: "#E5E7EB",
                    borderRadius: "100px",
                  },
                }}
                InputLabelProps={{
                  sx: {
                    color: "#6B7280",

                    fontWeight: 400,
                    "&.MuiFormLabel-filled": {
                      color: "#111827",

                      fontWeight: 400,
                    },
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                className={BankStyles.textfield}
                id="outlined-basic"
                label="Full Name"
                variant="outlined"
                name="fatherFullName"
                value={userData.fullName}
                inputProps={{
                  sx: {
                    "&::label": {
                      fill: "#111827",

                      fontWeight: 400,
                    },
                    color: "var(--Black-Black-500, #6B7280)",
                    fontSize: "14px",
                  },
                  maxLength: 50,
                  inputMode: "text",
                }}
                sx={{
                  fieldset: {
                    borderColor: "#E5E7EB",
                    borderRadius: "100px",
                  },
                }}
                InputLabelProps={{
                  sx: {
                    color: "#6B7280",

                    fontWeight: 400,
                    "&.MuiFormLabel-filled": {
                      color: "#111827",

                      fontWeight: 400,
                    },
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                className={BankStyles.textfield}
                id="outlined-basic"
                label="Email"
                variant="outlined"
                name="fatherFullName"
                value={userData.email}
                inputProps={{
                  sx: {
                    "&::label": {
                      fill: "#111827",
                      fontWeight: 500,
                    },
                    color: "var(--Black-Black-500, #6B7280)",
                    fontSize: "14px",
                  },
                  maxLength: 50,
                  inputMode: "text",
                }}
                sx={{
                  fieldset: {
                    borderColor: "#E5E7EB",
                    borderRadius: "100px",
                    height: "60px",
                  },
                }}
                InputLabelProps={{
                  sx: {
                    color: "#6B7280",
                    fontWeight: 500,
                    "&.MuiFormLabel-filled": {
                      color: "#111827", // Label color when the field has a value
                    },
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                className={BankStyles.textfield}
                id="outlined-basic"
                label="Mobile"
                variant="outlined"
                name="fatherFullName"
                value={userData.mobile}
                inputProps={{
                  sx: {
                    "&::label": {
                      fill: "#111827",
                      fontWeight: 500,
                    },
                    color: "var(--Black-Black-500, #6B7280)",
                    fontSize: "14px",
                  },
                  maxLength: 50,
                  inputMode: "text",
                }}
                sx={{
                  fieldset: {
                    borderColor: "#E5E7EB",
                    borderRadius: "100px",
                    height: "60px",
                  },
                }}
                InputLabelProps={{
                  sx: {
                    color: "#6B7280",
                    fontWeight: 500,
                    "&.MuiFormLabel-filled": {
                      color: "#111827", // Label color when the field has a value
                    },
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                className={BankStyles.textfield}
                id="outlined-basic"
                label="PAN"
                variant="outlined"
                name="fatherFullName"
                value={userData.pan}
                inputProps={{
                  sx: {
                    "&::label": {
                      fill: "#111827",
                      fontWeight: 500,
                    },
                    color: "var(--Black-Black-500, #6B7280)",
                    fontSize: "14px",
                  },
                  maxLength: 50,
                  inputMode: "text",
                }}
                sx={{
                  fieldset: {
                    borderColor: "#E5E7EB",
                    borderRadius: "100px",
                    height: "60px",
                  },
                }}
                InputLabelProps={{
                  sx: {
                    color: "#6B7280",
                    fontWeight: 500,
                    "&.MuiFormLabel-filled": {
                      color: "#111827", // Label color when the field has a value
                    },
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                className={BankStyles.textfield}
                id="outlined-basic"
                label="Trading Preference"
                variant="outlined"
                name="fatherFullName"
                value={
                  tradingPreference?.length > 0
                    ? tradingPreference.join(", ")
                    : "-"
                }
                inputProps={{
                  sx: {
                    "&::label": {
                      fill: "#111827",
                      fontWeight: 500,
                    },
                    color: "var(--Black-Black-500, #6B7280)",
                    fontSize: "14px",
                  },
                  maxLength: 50,
                  inputMode: "text",
                }}
                sx={{
                  fieldset: {
                    borderColor: "#E5E7EB",
                    borderRadius: "100px",
                    height: "60px",
                  },
                }}
                InputLabelProps={{
                  sx: {
                    color: "#6B7280",
                    fontWeight: 500,
                    "&.MuiFormLabel-filled": {
                      color: "#111827", // Label color when the field has a value
                    },
                  },
                }}
              />
            </Grid>
          </Grid>
        </div>

        <div className={BankStyles.buttonStack}>
          <LoadingButton
            loading={loading}
            variant="contained"
            type="submit"
            id="linkUsingIFSCContinueButton"
            className={BankStyles.approveButton}
            sx={{
              height: "50px",
            }}
            onClick={handleNext}
          >
            Continue
          </LoadingButton>
        </div>
      </div>
    </div>
  );
}
